import {
  Grid,
  Typography,
  Box
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import opd_img1 from "../../assets/images/facilities/opd/opd-img-1.jpg";
import opd_img2 from "../../assets/images/facilities/opd/opd-img-2.jpg";
import opd_img3 from "../../assets/images/facilities/opd/opd-img-3.jpg";
import opd_img4 from "../../assets/images/facilities/opd/opd-img-4.jpg";
import { ZoomInRounded } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import { useState } from "react";
import ContentLayout from "../../components/ContentLayout";

type ImageType = {
  src: string;
  alt: string;
};

type InfraObect = {
  name: string;
  img: Array<ImageType>;
};

const OPDdata: Array<InfraObect> = [
  {
    name: "OPD",
    img: [
      { src: opd_img1, alt: "opd_img1" },
      { src: opd_img2, alt: "opd_img2" },
      { src: opd_img3, alt: "opd_img3" },
      { src: opd_img4, alt: "opd_img4" },
    ],
  },
];

const OPD = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();
  return (
    <>
      <ContentLayout>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ position: "relative" }} >
              <ImageSlideshow
                sx={{}}
                images={OPDdata[0]?.img as Array<ImageType>}
                showCaption={false} showCount={false} />
              <Box
                sx={{
                  position: "absolute" as "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                onClick={() => {
                  setTitle(OPDdata[0]?.name);
                  setSliderImages(OPDdata[0]?.img);
                  setOpen(true);
                } }
              >
                <ZoomInRounded
                  sx={{
                    color: "#fdd025",
                    zIndex: 99,
                    fontSize: "4rem",
                    "&:hover": {
                      fontSize: "6rem",
                    },
                  }} />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
              The college boasts a well-equipped Outpatient Department (OPD) that serves as a hub for comprehensive physiotherapy care.
              Catering to an average of 25 to 50 patients daily, the OPD is a dynamic space where theory meets practice.
              Armed with state-of-the-art electrotherapy machines and a comprehensive array of therapeutic instruments, the department provides a robust treatment environment.
              The OPD witnesses a diverse patient profile, encompassing individuals with musculoskeletal conditions, cardiopulmonary challenges, neurological impairments in both adults and children, as well as those requiring community rehabilitation.
              This varied caseload offers invaluable clinical exposure to students, enabling them to apply theoretical knowledge to real-world scenarios.
              The OPD's role extends beyond patient care, serving as a platform for research, teaching, and community outreach, solidifying its position as a cornerstone of the college's academic and clinical excellence. 
            </Typography>
          </Grid>
        </Grid>
      </ContentLayout>
      
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={<Grid item xs={12} margin={"auto"}>
            <Box sx={{ width: "75%", margin: "auto" }}>
              <ImageSlider images={sliderImages} />
            </Box>
          </Grid>} />
      )}
    </>
  );
};

export default OPD;
